import { formatAddressComponents } from 'wanderu-utils';

// TODO: This type of mapping should live in the service or selectors
function formatGoogleLocation(response) {
    const {
        address_components,
        geometry,
        place_id,
    } = response;

    const addressParts = address_components.reduce((parts, comp) => {
        const {
            types,
            long_name,
            short_name,
        } = comp;

        if (types.includes('locality')) {
            return { ...parts, city: long_name };
        }

        if (types.includes('sublocality')) {
            return { ...parts, city: long_name };
        }

        if (types.includes('administrative_area_level_3')) {
            return { ...parts, city: long_name };
        }

        if (types.includes('postal_town')) {
            return { ...parts, city: long_name };
        }

        if (types.includes('administrative_area_level_1')) {
            return { ...parts, state: short_name };
        }

        if (types.includes('country')) {
            return {
                ...parts,
                countryLong: long_name,
                countryShort: short_name,
            };
        }

        return parts;
    }, {});

    const formattedAddress = formatAddressComponents(
        addressParts.city,
        addressParts.state,
        addressParts.countryShort,
    );

    const { lat, lng } = geometry.location;
    // The client SDK returns a function rather than the raw value
    const formattedLat = typeof lat === 'function'
        ? lat()
        : lat;
    const formattedLng = typeof lat === 'function'
        ? lng()
        : lng;

    return {
        lat: formattedLat,
        lng: formattedLng,
        formattedAddress,
        placeId: place_id,
        ...addressParts,
    };
}

export {
    formatGoogleLocation,
};
export default {
    formatGoogleLocation,
};
